module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img55.71da9512.jpg";